import router from './index'
import store from '../store/store'
import { Message } from 'element-ui'
import { loc } from '@/axios/storage'

const whiteList = ['/login', '/ResetPassword']

router.beforeEach(async(to, from, next) => {

    const hasToken = loc.get()
    if (hasToken) {
        if (to.path === '/login') {
            next({ path: '/home' })
        }else {
            const hasUser = store.state.users.userInfo.id
            if (hasUser) {
                next()
            } else {
                try {
                    await store.dispatch('users/getUserInfo') // 获取用户信息
                    next({...to, replace: true })
                } catch (error) {
                    await store.dispatch('users/resetToken')
                    Message.error(error || 'Has Error')
                    next(`/login?redirect=${to.path}`)
                }
            }
        }
    } else {
        next()
    }
})



// WEBPACK FOOTER //
// ./src/router/permission.js